const appView = () => {
	const authHeaderSearchParams = new URLSearchParams(window.location.search);
	const isAppView =
		authHeaderSearchParams
			.get('appview')
			?.toString()
			.toLowerCase() === 'true'
			? true
			: false;

	return isAppView;
};
export default appView;
